module.exports = __webpack_public_path__ + "media/images/teaser-trip-89dc8d6da92e03a55bbee43aecfea62d.jpg";